import { render } from "./Home.vue?vue&type=template&id=fae5bece&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=fae5bece&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fae5bece"
/* hot reload */
if (module.hot) {
  script.__hmrId = "fae5bece"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fae5bece', script)) {
    api.reload('fae5bece', script)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=fae5bece&scoped=true", () => {
    api.rerender('fae5bece', render)
  })

}

script.__file = "src/views/Home.vue"

export default script